import { IconPropsType } from '..';

export const ArrowLeftIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10.2434 10.7566L6.50471 6.99998L10.2434 3.24331L9.10007 2.09998L4.20007 6.99998L9.10007 11.9L10.2434 10.7566Z" />
  </svg>
);
